import { addMonths, isoDate, PLAN_STATUS } from "./finance";
import { roundMoney } from "./format";

export const emptyPlanRow = (dueDate = "", amount = "") => ({ dueDate, amount });

export const planSum = (rows = []) =>
  roundMoney(rows.reduce((total, row) => total + Number(row.amount || 0), 0));

export const seedEqualRows = ({ remaining, months, startDate }) => {
  const leftover = roundMoney(remaining);
  const count = Math.max(1, Number(months) || 1);
  if (leftover <= 0) return [];

  const base = roundMoney(leftover / count);
  const rows = [];
  let allocated = 0;
  const start = startDate || isoDate();

  for (let index = 0; index < count; index += 1) {
    const amount = index === count - 1 ? roundMoney(leftover - allocated) : base;
    allocated = roundMoney(allocated + amount);
    rows.push(emptyPlanRow(addMonths(start, index + 1), String(amount)));
  }

  return rows;
};

export const unpaidPlanItems = (plan = []) =>
  plan.filter((item) => item.status !== PLAN_STATUS.PAID);

export const paidPlanItems = (plan = []) =>
  plan.filter((item) => item.status === PLAN_STATUS.PAID || Number(item.paidAmount) > 0);

export const rowsFromPlan = (plan = []) =>
  unpaidPlanItems(plan).map((item) =>
    emptyPlanRow(
      item.dueDate || "",
      String(roundMoney((item.amount || 0) - (item.paidAmount || 0)))
    )
  );

export const customPlanPayload = (rows = []) =>
  rows
    .filter((row) => row.dueDate && Number(row.amount) > 0)
    .map((row) => ({ dueDate: row.dueDate, amount: Number(row.amount) }));

export const planMatchesRemaining = (rows, remaining) =>
  roundMoney(planSum(rows)) === roundMoney(remaining);
